import { MouseEvent, ReactNode } from 'react';
import { SecurityCardAnchor } from '../security-card-anchors';

export type CardAnchorLinkProps = {
  anchor: SecurityCardAnchor;
  children: ReactNode;
};

/**
 * A link to another card of the page. It scrolls rather than navigating, so the router never sees
 * a hash it has no route for, and moves the focus there for keyboard and screen-reader users.
 */
export function CardAnchorLink({ anchor, children }: CardAnchorLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.getElementById(anchor);
    target?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
    target?.focus?.({ preventScroll: true });
  };

  return (
    <a href={`#${anchor}`} onClick={handleClick} className="underline">
      {children}
    </a>
  );
}
